import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space3XL, space4XL, spaceL } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

const StyledGridContainer = styled(GridContainer)`
  align-items: center;
  margin-top: ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space3XL};
  }
`;

const Header = styled.header`
  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceL};
  }
`;

const StyledHero = styled(Hero)`
  margin-bottom: ${spaceL};
`;

const LoggedOutImage = styled.img`
  max-width: 100%;
`;

export const Styled = {
  GridContainer: StyledGridContainer,
  Header,
  Hero: StyledHero,
  LoggedOutImage,
};
